export const V1_RESET_ERRORS = 'V1_RESET_ERRORS'

export default () => ({
  type: V1_RESET_ERRORS,
})
